var CALCULATOR_FORM = {
	"Chain Link - Galvanized":{
	   "Residential":{
		  "36\" Chain Link":{
			 "Galvanized":"36-residential-galvanized-chain-link"
		  },
		  "42\" Chain Link":{
			 "Galvanized":"42-residential-galvanized-chain-link"
		  },
		  "48\" Chain Link":{
			 "Galvanized":"48-residential-galvanized-chain-link"
		  },
		  "60\" Chain Link":{
			 "Galvanized":"60-residential-galvanized-chain-link"
		  },
		  "72\" Chain Link":{
			 "Galvanized":"72-residential-galvanized-chain-link"
		  }
	   },
	   "Light Commercial .055":{
         "48\" Chain link":{
			 "Galvanized":"48-light-commercial-galvanized-chain-link"
		  },
         "60\" Chain link":{
			 "Galvanized":"60-light-commercial-galvanized-chain-link"
		  },
         "72\" Chain link":{
			 "Galvanized":"72-light-commercial-galvanized-chain-link"
		  }        
	   },
       "Medium Commercial .085":{
         "48\" Chain link":{
			 "Galvanized":"48-medium-commercial-galvanized-chain-link"
		  },
         "60\" Chain link":{
			 "Galvanized":"60-medium-commercial-galvanized-chain-link"
		  },
         "72\" Chain link":{
			 "Galvanized":"72-medium-commercial-galvanized-chain-link"
		  }  
	   },
       "Medium Commercial .085 (Barbwire)":{
         "72\" Chain link":{
			 "Galvanized":"72-medium-commercial-galvanized-chain-link-barbwire"
		  }        
	   },      
       "Heavy Commercial .110":{
         "48\" Chain link":{
			 "Galvanized":"48-heavy-commercial-galvanized-chain-link"
		  },
         "60\" Chain link":{
			 "Galvanized":"60-heavy-commercial-galvanized-chain-link"
		  },
         "72\" Chain link":{
			 "Galvanized":"72-heavy-commercial-galvanized-chain-link"
		  },
         "84\" Chain link":{
			 "Galvanized":"84-heavy-commercial-galvanized-chain-link"
		  },         
          "96\" Chain link":{
			 "Galvanized":"96-heavy-commercial-galvanized-chain-link"
		  },
          "120\" Chain link":{
			 "Galvanized":"120-heavy-commercial-galvanized-chain-link"
		  },  
          "144\" Chain link":{
			 "Galvanized":"144-heavy-commercial-galvanized-chain-link"
		  }         
	   },      
       "Heavy Commercial .110 (Barbwire)":{
         "72\" Chain link":{
			 "Galvanized":"72-heavy-commercial-galvanized-chain-link-barbwire"
		 },
         "84\" Chain link":{
			 "Galvanized":"84-heavy-commercial-galvanized-chain-link-barbwire"
		 },
         "96\" Chain link":{
    		 "Galvanized":"96-heavy-commercial-galvanized-chain-link-barbwire"
		 },
         "120\" Chain link":{
			 "Galvanized":"120-heavy-commercial-galvanized-chain-link-barbwire"
		 },  
         "144\" Chain link":{
		 "Galvanized":"144-heavy-commercial-galvanized-chain-link-barbwire"
		 }  
	   }      
    },
    "Chain Link - Black":{
	   "Residential":{
		  "42\" Chain link":{
			 "Black":"42-residential-black-chain-link"
		  },
		  "48\" Chain link":{
			 "Black":"48-residential-black-chain-link"
		  },
		  "60\" Chain link":{
			 "Black":"60-residential-black-chain-link"
		  },
		  "72\" Chain link":{
			 "Black":"72-residential-black-chain-link"
		  }
	   },
	   "Light Commercial .055":{     
          "48\" Chain link":{
             "Black":"48-light-commercial-black-chain-link"
		  },
          "72\" Chain link":{
             "Black":"72-light-commercial-black-chain-link"
		  }
	   },
       "Medium Commercial .085":{
		  "48\" Chain link":{
             "Black":"48-medium-commercial-black-chain-link"
		  },
          "72\" Chain link":{
             "Black":"72-medium-commercial-black-chain-link"
		  },        
          "96\" Chain link":{
             "Black":"96-medium-commercial-black-chain-link"
		  }         
	   },
       "Medium Commercial .085 (Barbwire)":{
          "72\" Chain link (Barbwire)":{
             "Black":"72-medium-commercial-black-chain-link-barbwire"
		  },         
          "96\" Chain link (Barbwire)":{
             "Black":"96-medium-commercial-black-chain-link-barbwire"
		  }         
	   },      
	   "Heavy Commercial .110":{
          "48\" Chain link":{
             "Black":"48-heavy-commercial-black-chain-link"
		  },
          "72\" Chain link":{
             "Black":"72-heavy-commercial-black-chain-link"
		  },         
          "96\" Chain link":{
             "Black":"96-heavy-commercial-black-chain-link"
		  }
	   },
	   "Heavy Commercial .110 (Barbwire)":{
          "72\" Chain link (Barbwire)":{
             "Black":"72-heavy-commercial-black-chain-link-barbwire"
		  },         
          "96\" Chain link (Barbwire)":{
             "Black":"96-heavy-commercial-black-chain-link-barbwire"
		  }
	   }      
	},
	"Vinyl":{
	   "Privacy":{
		  "6' Privacy":{
			 "White":"6-vinyl-privacy-fence-afc-373-white",
			 "Tan":"6-vinyl-privacy-fence-afc-373-tan",
			 "Adobe":"6-vinyl-privacy-fence-afc-373-adobe",
			 "Light Gray":"6-vinyl-privacy-fence-afc-373-light-gray",
			 "Dark Gray":"6-vinyl-privacy-fence-afc-373-dark-gray",
			 "Mocha Walnut":"6-vinyl-privacy-fence-afc-373-mocha-walnut",
			 "Green Teak":"6-vinyl-privacy-fence-afc-373-green-teak",
			 "Chai Gray":"6-vinyl-privacy-fence-afc-373-chai-gray",
			 "Aspen Latte":"6-vinyl-privacy-fence-afc-373-aspen-latte"
		  },
		  "6' Privacy with Accent":{
			 "White":"6-vinyl-privacy-fence-w-picket-accent-afc-018-white",
			 "Tan":"6-vinyl-privacy-fence-w-picket-accent-afc-018-tan",				 
			 "Adobe":"6-vinyl-privacy-fence-w-picket-accent-afc-018-adobe"
		  },
		  "4' Privacy":{
			 "White":"4-vinyl-privacy-fence-afc-001-white",
			 "Tan":"4-vinyl-privacy-fence-afc-001-tan",
			 "Adobe":"4-vinyl-privacy-fence-afc-001-adobe"
			//  "Light Gray":"4-vinyl-privacy-fence-afc-001-light-gray",
			//  "Dark Gray":"4-vinyl-privacy-fence-afc-001-dark-gray",
			//  "Mocha Walnut":"4-vinyl-privacy-fence-afc-001-mocha-walnut",
			//  "Green Teak":"4-vinyl-privacy-fence-afc-001-green-teak",
			//  "Chai Gray":"4-vinyl-privacy-fence-afc-001-chai-gray",
			//  "Aspen Latte":"4-vinyl-privacy-fence-afc-001-aspen-latte"			 
		  }
	   },
	   "Semi-Privacy":{
		  "6' Semi-Privacy (2 Rail)":{
			 "White":"6-vinyl-semi-privacy-fence-afc-030-white",
			 "Tan":"6-vinyl-semi-privacy-fence-afc-030-tan"
			//  "Adobe":"6-vinyl-semi-privacy-fence-afc-030-adobe",
			//  "Light Gray":"6-vinyl-semi-privacy-fence-afc-030-light-gray",
			//  "Dark Gray":"6-vinyl-semi-privacy-fence-afc-030-dark-gray"
		  },
		  "6' Semi-Privacy (3 Rail)":{
			 "White":"6-vinyl-semi-private-picket-fence-afc-034-white",
			 "Tan":"6-vinyl-semi-private-picket-fence-afc-034-tan"
			//  "Adobe":"6-vinyl-semi-private-picket-fence-afc-034-adobe",
			//  "Light Gray":"6-vinyl-semi-private-picket-fence-afc-034-light-gray",
			//  "Dark Gray":"6-vinyl-semi-private-picket-fence-afc-034-dark-gray"
		  },
		  "6' Alternating Picket":{
			 "White":"6-vinyl-alternating-picket-fence-afs-23-white",
			 "Tan":"6-vinyl-alternating-picket-fence-afs-23-tan"
			//  "Adobe":"6-vinyl-alternating-picket-fence-afs-23-adobe",
			//  "Light Gray":"6-vinyl-alternating-picket-fence-afs-23-light-gray",
			//  "Dark Gray":"6-vinyl-alternating-picket-fence-afs-23-dark-gray"
		  },		  
		  "5' Semi-Privacy":{
			 "White":"5-vinyl-semi-privacy-fence-afc-006-white",
			 "Tan":"5-vinyl-semi-privacy-fence-afc-006-tan"
			//  "light-gray":"5-vinyl-semi-privacy-fence-afc-006-light-gray",
			//  "dark-gray":"5-vinyl-semi-privacy-fence-afc-006-dark-gray"
		  },
		  "4' Semi Privacy":{
			 "White":"4-vinyl-semi-privacy-fence-afc-0304-white",
			 "Tan":"4-vinyl-semi-privacy-fence-afc-0304-tan"
			//  "Light Gray":"4-vinyl-semi-privacy-fence-afc-0304-light-gray",
			//  "Dark Gray":"4-vinyl-semi-privacy-fence-afc-0304-dark-gray"
		  }
	   },
	   "Picket":{
		  "4' Picket":{
			 "White":"4-vinyl-picket-fence-afc-15-white",
			 "Tan":"4-vinyl-picket-fence-afc-15-tan",
			 "Adobe":"4-vinyl-picket-fence-afc-15-adobe"
			//  "Light Gray":"4-vinyl-picket-fence-afc-15-light-gray",
			//  "Dark Gray":"4-vinyl-picket-fence-afc-15-dark-gray"			 
		  },
		  "3' Picket":{
			 "White":"3-vinyl-straight-routed-picket-fence-afc-11-white",
			 "Tan":"3-vinyl-straight-routed-picket-fence-afc-11-tan",
			 "Adobe":"3-vinyl-straight-routed-picket-fence-afc-11-adobe"
			//  "Light Gray":"3-vinyl-straight-routed-picket-fence-afc-11-light-gray",
			//  "Dark Gray":"3-vinyl-straight-routed-picket-fence-afc-11-dark-gray"			 
		  }		  
	   },
	   "Closed Picket":{
		  "6' Pool Picket":{
			"White":"6-vinyl-pool-picket-fence-afc-017-white",
			"Tan":"6-vinyl-pool-picket-fence-afc-017-tan"
			// "Adobe":"6-vinyl-pool-picket-fence-afc-017-adobe",
			// "Light Gray":"6-vinyl-pool-picket-fence-afc-017-light-gray",
			// "Dark Gray":"6-vinyl-pool-picket-fence-afc-017-dark-gray"
		  },	
		  "5' Closed Picket":{
			 "White":"5-vinyl-closed-picket-fence-afc-014-white",
			 "Tan":"5-vinyl-closed-picket-fence-afc-014-tan",
			 "Adobe":"5-vinyl-closed-picket-fence-afc-014-adobe"
			 // "Light Gray":"5-vinyl-closed-picket-fence-afc-014-light-gray",
			 // "Dark Gray":"5-vinyl-closed-picket-fence-afc-014-dark-gray"			 
		  },
		  "4' Closed Picket":{
			 "White":"4-vinyl-closed-picket-fence-afc-17-white",
			 "Tan":"4-vinyl-closed-picket-fence-afc-17-tan",
			 "Adobe":"4-vinyl-closed-picket-fence-afc-17-adobe"
			 // "Light Gray":"4-vinyl-closed-picket-fence-afc-17-light-gray",
			 // "Dark Gray":"4-vinyl-closed-picket-fence-afc-17-dark-gray"
		  },
		  "3' Closed Picket":{
			 "White":"3-vinyl-closed-picket-fence-afc-16-white",
			 "Tan":"3-vinyl-closed-picket-fence-afc-16-tan",
			 "Adobe":"3-vinyl-closed-picket-fence-afc-16-adobe"
			 // "Light Gray":"3-vinyl-closed-picket-fence-afc-16-light-gray",
			 // "Dark Gray":"3-vinyl-closed-picket-fence-afc-16-dark-gray"
		  }		  
	   },
	   "Overscallop Picket":{
		  "6' Overscallop":{
			 "White":"6-vinyl-overscallop-picket-afc-012-white",
			 "Tan":"6-vinyl-overscallop-picket-afc-012-tan"
			 // "Adobe":"6-vinyl-overscallop-picket-afc-012-adobe",
			 // "Light Gray":"6-vinyl-overscallop-picket-afc-012-light-gray",
			 // "Dark Gray":"6-vinyl-overscallop-picket-afc-012-dark-gray"
		  },
		  "5' Overscallop":{
			 "White":"5-vinyl-overscallop-picket-fence-afc-004-white",
			 "Tan":"5-vinyl-overscallop-picket-fence-afc-004-tan"
			 // "Adobe":"5-vinyl-overscallop-picket-fence-afc-004-adobe",
			 // "Light Gray":"5-vinyl-overscallop-picket-fence-afc-004-light-gray",
			 // "Dark Gray":"5-vinyl-overscallop-picket-fence-afc-004-dark-gray"
		  },
		  "4' Overscallop":{
			 "White":"4-vinyl-overscallop-picket-fence-afc-016-white",
			 "Tan":"4-vinyl-overscallop-picket-fence-afc-016-tan",
			 "Adobe":"4-vinyl-overscallop-picket-fence-afc-016-adobe"
			 // "Light Gray":"4-vinyl-overscallop-picket-fence-afc-016-light-gray",
			 // "Dark Gray":"4-vinyl-overscallop-picket-fence-afc-016-dark-gray"
		  }
	   },
	   "Underscallop Picket":{
		  "6' Underscallop":{
			 "White":"6-vinyl-underscallop-picket-fence-afc-013-white",
			 "Tan":"6-vinyl-underscallop-picket-fence-afc-013-tan"
			 // "Adobe":"6-vinyl-underscallop-picket-fence-afc-013-adobe",
			 // "Light Gray":"6-vinyl-underscallop-picket-fence-afc-013-light-gray",
			 // "Dark Gray":"6-vinyl-underscallop-picket-fence-afc-013-dark-gray"
		  },
		  "5' Underscallop":{
			 "White":"5-vinyl-underscallop-picket-fence-afc-003-white",
			 "Tan":"5-vinyl-underscallop-picket-fence-afc-003-tan"
			 // "Adobe":"5-vinyl-underscallop-picket-fence-afc-003-adobe",
			 // "Light Gray":"5-vinyl-underscallop-picket-fence-afc-003-light-gray",
			 // "Dark Gray":"5-vinyl-underscallop-picket-fence-afc-003-dark-gray"
		  },
		  "4' Underscallop":{
			 "White":"4-vinyl-underscallop-picket-fence-afc-97-white",
			 "Tan":"4-vinyl-underscallop-picket-fence-afc-97-tan",
			 "Adobe":"4-vinyl-underscallop-picket-fence-afc-97-adobe"
			 // "Light Gray":"4-vinyl-underscallop-picket-fence-afc-97-light-gray",
			 // "Dark Gray":"4-vinyl-underscallop-picket-fence-afc-97-dark-gray"
		  }
	   },
	   "Ranch Rail":{
		  "5' (3 rail)":{
			 "White":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-white"
			//  "Tan":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-tan",
			//  "Adobe":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-adobe",
			//  "Light Gray":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-light-gray",
			//  "Dark Gray":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-dark-gray",
			//  "Mocha Walnut":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-mocha-walnut",
			//  "Green Teak":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-green-teak",
			//  "Chai Gray":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-chai-gray",
			//  "Aspen Latte":"5-vinyl-3-rail-ranch-rail-fence-afc-19a-aspen-latte"			
		  },
		  "3' (2 rail)":{
			 "White":"3-vinyl-2-rail-ranch-rail-fence-afc-302-white"
			//  "Tan":"3-vinyl-2-rail-ranch-rail-fence-afc-302-tan",
			//  "Adobe":"3-vinyl-2-rail-ranch-rail-fence-afc-302-adobe",
			//  "Light Gray":"3-vinyl-2-rail-ranch-rail-fence-afc-302-light-gray",
			//  "Dark Gray":"3-vinyl-2-rail-ranch-rail-fence-afc-302-dark-gray",
			//  "Mocha Walnut":"3-vinyl-2-rail-ranch-rail-fence-afc-302-mocha-walnut",
			//  "Green Teak":"3-vinyl-2-rail-ranch-rail-fence-afc-302-green-teak",
			//  "Chai Gray":"3-vinyl-2-rail-ranch-rail-fence-afc-302-chai-gray",
			//  "Aspen Latte":"3-vinyl-2-rail-ranch-rail-fence-afc-302-aspen-latte"
		  }
	   }
	},  
	"Ornamental - Steel":{
	   "Puppy Picket":{
		"4' Puppy Picket Flat Top":{
			"Black":"4-flat-top-puppy-ornamental-iron"
		 },
		"6' Puppy Picket Flat Top":{
			"Black":"6-flat-top-puppy-ornamental-iron"
		 },		 
	   },	
	   "Flat Top":{
		"4' Steel Flat Top":{
            "Black":"4-flat-top-ornamental-iron"
         },
         "5' Steel Flat Top":{
            "Black":"5-flat-top-ornamental-iron"
         },
         "6' Steel Flat Top":{
            "Black":"6-flat-top-ornamental-iron"
         }
	   },
	   "Spear Top":{
        "5' Steel Spear Top":{
            "Black":"5-spear-top-ornamental-iron"
         },
         "6' Steel Spear Top":{
            "Black":"6-spear-top-ornamental-iron"
         }
	   }
	},
	"Ornamental - Aluminum":{
	   "Flat Top":{
			"4' Flat Top":{
				"Black":"4-aluminum-flat-top-ornamental"
			},
			"5' Flat Top":{
				"Black":"5-aluminum-flat-top-ornamental"
			},
			"6' Flat Top":{
				"Black":"6-aluminum-flat-top-ornamental"
			}		
	    }
	},	
	"Wood":{
		"Solid / Privacy":{
		   "6' Solid Privacy with 5.5\" Pickets":{
			  "Cedar":"6-solid-wood" 
			  //"White Fir":"6-solid-wood",
			  //"Western Red Cedar":"6-solid-wood"
		   },
		   //"6' Solid with Custom 4\" Pickets":{
			  //"Cedar":"6-solid-wood-with-custom-4-pickets",
			  //"Western Red Cedar":"6-solid-wood-with-custom-4-pickets"
		   //},
		   "4' Solid Wood with 5.5\" Pickets":{
			  "Cedar":"4-solid-wood"
		   }
		},
		"Shadow Box":{
		   "6' Shadow Box with 5.5\" Pickets":{
			  "Cedar":"6-shadow-box-wood",
			  //"Western Red Cedar":"6-shadow-box-wood"
		   },
		   // "6' Shadow Box with Custom 4\" Pickets":{
		   //    "Cedar":"6-shadow-box-wood-with-custom-4-pickets",
		   //    //"Western Red Cedar":"6-shadow-box-wood-with-custom-4-pickets"
		   // },
		   // "4' Shadow Box with 4\" Pickets":{
		   //    "Cedar":"4-shadow-box-wood-with-4-pickets"
		   // },
		   "4' Shadow Box with 5.5\" Pickets":{
			  "Cedar":"4-shadow-box-wood-with-6-pickets"
		   }
		},
		"Picket":{
		   "6' Semi-Privacy - 5.5\" Pickets (1\" gap)":{
			  "Cedar":"6-picket-wood-w-1-gap",
			  //"Western Red Cedar":"6-picket-wood-w-1-gap"
		   },
		   // "6' French Gothic with 5.5\" Pickets (1\" gap)":{
		   //    "Cedar":"6-french-gothic-wood",
		   //    //"Western Red Cedar":"6-french-gothic-wood"
		   // },
		   // "6' Picket with 4\" pickets":{
		   //    "Cedar":"6-picket-wood-with-4-pickets",
		   //    //"Western Red Cedar":"6-picket-wood-with-4-pickets"
		   // },
		   "4' Picket Fence - 3.5\" Pickets (3\" gap)":{
			  "Cedar":"4-picket-wood-fence"
		   }  
		   // "4' French Gothic":{
		   //    "Cedar":"4-french-gothic-wood"
		   // }
		   
		   // "4' Picket w\/Capboard":{
		   //    "Cedar":"4-picket-wood-w-capboard"
		   // }
		},
		"Scalloped":{
			"6' Shadow Box - 5.5\" Pickets":{
				"Cedar":"6-shadow-box-scalloped-wood"
			 },
			 "6' Solid Privacy - 5.5\" Pickets":{
				"Cedar":"6-solid-scalloped-wood",
				//"Western Red Cedar":"6-solid-scalloped-wood"
			 },
			 "6' Picket - 5.5\" Pickets (1\" gap)":{
				"Cedar":"6-picket-scalloped-wood",
				//"Western Red Cedar":"6-picket-scalloped-wood"
			 },
			 "4' Shadow Box - 5.5\" Pickets":{
				"Cedar":"4-shadow-box-scalloped-wood"
			 },
			 "4' Solid Wood - 5.5\" Pickets":{
				"Cedar":"4-solid-scalloped-wood"
			 },
			 "4' Picket - 3.5\" Pickets (3\" gap) ":{
				"Cedar":"4-picket-scalloped-wood"
			 }
		}
	 }
 }
 
 var VINYL_OPENINGS = {
   
	 //******* generic gate references unless noted, need to update variants when new pictures are available ********
 

   
	 "6-vinyl-privacy-fence-afc-373-white" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373WH5SS"
		 },		 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373WH8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373WH10DD"
		 }
	 ],
 	 "6-vinyl-privacy-fence-afc-373-tan" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373TAN5SS"
		 },		 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373TAN8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373TAN10DD"
		 }
	 ],
  	 "6-vinyl-privacy-fence-afc-373-adobe" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373AD8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373AD10DD"
		 }
	 ],
   	 "6-vinyl-privacy-fence-afc-373-light-gray" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373LG3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373LG4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373LG5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373LG6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373LG8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373LG10DD"
		 }
	 ],
   	 "6-vinyl-privacy-fence-afc-373-dark-gray" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373DG3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373DG4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373DG5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373DG6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373DG8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373DG10DD"
		 }
	 ],
   	 "6-vinyl-privacy-fence-afc-373-mocha-walnut" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373MW3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373MW4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373MW5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373MW6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373MW8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373MW10DD"
		 }
	 ],
   	 "6-vinyl-privacy-fence-afc-373-green-teak" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373GT3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373GT4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373GT5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373GT6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373GT8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373GT10DD"
		 }
	 ],
   	 "6-vinyl-privacy-fence-afc-373-chai-gray" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373CG3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373CG4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373CG5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373CG6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373CG8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373CG10DD"
		 }
	 ],
   	 "6-vinyl-privacy-fence-afc-373-aspen-latte" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC373AL3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC373AL4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC373AL5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC373AL6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC373AL8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC373AL10DD"
		 }
	 ], 
	 "6-vinyl-privacy-fence-w-picket-accent-afc-018-white" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC018WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC018WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC018WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC018WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC018WH8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC018WH10DD"
		 }
	 ],
	 "6-vinyl-privacy-fence-w-picket-accent-afc-018-tan" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC018TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC018TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC018TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC018TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC018TAN8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC018TAN10DD"
		 }
	 ],
	 "6-vinyl-privacy-fence-w-picket-accent-afc-018-adobe" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC018AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC018AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC018AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC018AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC018AD8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC018AD10DD"
		 }
	 ],
	 "4-vinyl-privacy-fence-afc-001-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC001WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC001WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC001WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC001WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC001WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC001WH10DD"
		 }
	 ],  
	 "4-vinyl-privacy-fence-afc-001-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC001TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC001TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC001TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC001TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC001TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC001TAN10DD"
		 }
	 ],  
	 "4-vinyl-privacy-fence-afc-001-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC001AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC001AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC001AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC001AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC001AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC001AD10DD"
		 }
	 ],
	//  "4-vinyl-privacy-fence-afc-001-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	//   {
	// 	 	 "Key": "Single",
	// 	 	 "Name": "Single Gate (5' opening)",
	// 	  	 "Opening": 5,
	// 	 	 "ID": ""
	//   },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "4-vinyl-privacy-fence-afc-001-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	//   {
	// 	 	 "Key": "Single",
	// 	 	 "Name": "Single Gate (5' opening)",
	// 	  	 "Opening": 5,
	// 	 	 "ID": ""
	//   },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "4-vinyl-privacy-fence-afc-001-mocha-walnut": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	//   {
	// 	 	 "Key": "Single",
	// 	 	 "Name": "Single Gate (5' opening)",
	// 	  	 "Opening": 5,
	// 	 	 "ID": ""
	//   },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "4-vinyl-privacy-fence-afc-001-green-teak": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	//   {
	// 	 	 "Key": "Single",
	// 	 	 "Name": "Single Gate (5' opening)",
	// 	  	 "Opening": 5,
	// 	 	 "ID": ""
	//   },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "4-vinyl-privacy-fence-afc-001-chai-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	//   {
	// 	 	 "Key": "Single",
	// 	 	 "Name": "Single Gate (5' opening)",
	// 	  	 "Opening": 5,
	// 	 	 "ID": ""
	//   },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "4-vinyl-privacy-fence-afc-001-aspen-latte": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	//   {
	// 	 	 "Key": "Single",
	// 	 	 "Name": "Single Gate (5' opening)",
	// 	  	 "Opening": 5,
	// 	 	 "ID": ""
	//   },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	 	 	 	 	 	 
	 "6-vinyl-semi-privacy-fence-afc-030-white" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC030WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC030WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC030WH5SS"
		 },            
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC030WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC030WH8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC030WH10DD"
		 }
	 ],
	 "6-vinyl-semi-privacy-fence-afc-030-tan" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC030TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC030TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC030TAN5SS"
		 },               
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC030TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC030TAN8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC030TAN10DD"
		 }
	 ],
	//  "6-vinyl-semi-privacy-fence-afc-030-adobe" : [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "6-vinyl-semi-privacy-fence-afc-030-light-gray" : [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "6-vinyl-semi-privacy-fence-afc-030-dark-gray" : [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	 	 	  
	 "6-vinyl-semi-private-picket-fence-afc-034-white" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC034WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC034WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC034WH5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC034WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC034WH8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC034WH10DD"
		 }
	 ],
	 "6-vinyl-semi-private-picket-fence-afc-034-tan" : [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC034TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC034TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC034TAN5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC034TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC034TAN8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC034TAN10DD"
		 }
	 ],
	//  "6-vinyl-semi-private-picket-fence-afc-034-adobe" : [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "6-vinyl-semi-private-picket-fence-afc-034-light-gray" : [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "6-vinyl-semi-private-picket-fence-afc-034-dark-gray" : [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	
	
	"6-vinyl-alternating-picket-fence-afs-23-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFS23WH3SS"
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFS23WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFS23WH5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFS23WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFS23WH8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFS23WH10DD"
		 }
	 ], 
	"6-vinyl-alternating-picket-fence-afs-23-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFS23TAN3SS"
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFS23TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFS23TAN5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFS23TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFS23TAN8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFS23TAN10DD"
		 }
	 ], 
	// "6-vinyl-alternating-picket-fence-afs-23-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	   {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	// "6-vinyl-alternating-picket-fence-afs-23-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	   {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	// "6-vinyl-alternating-picket-fence-afs-23-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	   {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 	 	 	 	 

	 "5-vinyl-semi-privacy-fence-afc-006-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC006WH3SS"
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC006WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC006WH5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC006WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC006WH8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC006WH10DD"
		 }
	 ],
	 "5-vinyl-semi-privacy-fence-afc-006-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC006TAN3SS"
		 },
		   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC006TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC006TAN5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC006TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC006TAN8DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC006TAN10DD"
		 }
	 ],	 
	//  "5-vinyl-semi-privacy-fence-afc-006-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	   {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	 
	//  "5-vinyl-semi-privacy-fence-afc-006-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	   {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	 	 	 
 
	 "4-vinyl-semi-privacy-fence-afc-0304-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC0304WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC0304WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC0304WH5SS"
		 }, 
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC0304WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC0304WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC0304WH10DD"
		 }
	 ],  
	 "4-vinyl-semi-privacy-fence-afc-0304-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC0304TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC0304TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC0304TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC0304TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC0304TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC0304TAN10DD"
		 }
	 ],     
	//  "4-vinyl-semi-privacy-fence-afc-0304-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "4-vinyl-semi-privacy-fence-afc-0304-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  	 	     
 
	 "4-vinyl-picket-fence-afc-15-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC15WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC15WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC15WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC15WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC15WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC15WH10DD"
		 }
	 ],  
	 "4-vinyl-picket-fence-afc-15-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC15TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC15TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC15TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC15TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC15TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC15TAN10DD"
		 }
	 ],  
	 "4-vinyl-picket-fence-afc-15-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC15AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC15AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC15AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC15AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC15AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC15AD10DD"
		 }
	 ],  
	//  "4-vinyl-picket-fence-afc-15-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "4-vinyl-picket-fence-afc-15-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  	 	 	 	 
 
	 "3-vinyl-straight-routed-picket-fence-afc-11-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC11WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC11WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC11WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC11WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC11WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC11WH10DD"
		 }
	 ],  
	 "3-vinyl-straight-routed-picket-fence-afc-11-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC11TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC11TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC11TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC11TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC11TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC11TAN10DD"
		 }
	 ],  
	 "3-vinyl-straight-routed-picket-fence-afc-11-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC11AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC11AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC11AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC11AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC11AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC11AD10DD"
		 }
	 ],  
	//  "3-vinyl-straight-routed-picket-fence-afc-11-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "3-vinyl-straight-routed-picket-fence-afc-11-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  	
	
	 "6-vinyl-pool-picket-fence-afc-017-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC017WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC017WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC017WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC017WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC017WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC017WH10DD"
		 }
	 ],  
	 "6-vinyl-pool-picket-fence-afc-017-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC017TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC017TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC017TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC017TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC017TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC017TAN10DD"
		 }
	 ], 
	//  "6-vinyl-pool-picket-fence-afc-017-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "6-vinyl-pool-picket-fence-afc-017-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "6-vinyl-pool-picket-fence-afc-017-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  			
 
 	 "5-vinyl-closed-picket-fence-afc-014-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC014WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC014WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC014WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC014WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC014WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC014WH10DD"
		 }
	 ],  
	 "5-vinyl-closed-picket-fence-afc-014-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC014TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC014TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC014TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC014TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC014TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC014TAN10DD"
		 }
	 ], 
 	//  "5-vinyl-closed-picket-fence-afc-014-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "5-vinyl-closed-picket-fence-afc-014-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "5-vinyl-closed-picket-fence-afc-014-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  

	 "4-vinyl-closed-picket-fence-afc-17-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC17WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC17WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC17WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC17WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC17WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC17WH10DD"
		 }
	 ], 
	 "4-vinyl-closed-picket-fence-afc-17-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC17TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC17TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC17TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC17TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC17TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC17TAN10DD"
		 }
	 ],  
  	 "4-vinyl-closed-picket-fence-afc-17-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC17AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC17AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC17AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC17AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC17AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC17AD10DD"
		 }
	 ],  
	//  "4-vinyl-closed-picket-fence-afc-17-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "4-vinyl-closed-picket-fence-afc-17-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  

	 "3-vinyl-closed-picket-fence-afc-16-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC16WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC16WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC16WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC16WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC16WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC16WH10DD"
		 }
	 ],  
		 "3-vinyl-closed-picket-fence-afc-16-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC16TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC16TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC16TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC16TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC16TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC16TAN10DD"
		 }
	 ], 
	 "3-vinyl-closed-picket-fence-afc-16-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC16AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC16AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC16AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC16AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC16AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC16AD10DD"
		 }
	 ],  
		//  "3-vinyl-closed-picket-fence-afc-16-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "3-vinyl-closed-picket-fence-afc-16-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  

	 "6-vinyl-overscallop-picket-afc-012-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC012WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC012WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC012WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC012WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC012WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC012WH10DD"
		 }
	 ], 
	 "6-vinyl-overscallop-picket-afc-012-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC012TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC012TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC012TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC012TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC012TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC012TAN10DD"
		 }
	 ],  
 	//  "6-vinyl-overscallop-picket-afc-012-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "6-vinyl-overscallop-picket-afc-012-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "6-vinyl-overscallop-picket-afc-012-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  	

  	 "5-vinyl-overscallop-picket-fence-afc-004-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC004WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC004WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC004WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC004WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC004WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC004WH10DD"
		 }
	 ],  
	 "5-vinyl-overscallop-picket-fence-afc-004-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC004TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC004TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC004TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC004TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC004TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC004TAN10DD"
		 }
	 ], 
 	//  "5-vinyl-overscallop-picket-fence-afc-004-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "5-vinyl-overscallop-picket-fence-afc-004-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "5-vinyl-overscallop-picket-fence-afc-004-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
 

 	 "4-vinyl-overscallop-picket-fence-afc-016-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC016WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC016WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC016WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC016WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC016WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC016WH10DD"
		 }
	 ],  
	 "4-vinyl-overscallop-picket-fence-afc-016-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC016TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC016TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC016TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC016TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC016TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC016TAN10DD"
		 }
	 ],  
 	 "4-vinyl-overscallop-picket-fence-afc-016-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC016AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC016AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC016AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC016AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC016AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC016AD10DD"
		 }
	 ],  
	//  "4-vinyl-overscallop-picket-fence-afc-016-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "4-vinyl-overscallop-picket-fence-afc-016-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
 
 	 "6-vinyl-underscallop-picket-fence-afc-013-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC013WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC013WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC013WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC013WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC013WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC013WH10DD"
		 }
	 ], 
	 "6-vinyl-underscallop-picket-fence-afc-013-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC013TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC013TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC013TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC013TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC013TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC013TAN10DD"
		 }
	 ],  
 	//  "6-vinyl-underscallop-picket-fence-afc-013-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "6-vinyl-underscallop-picket-fence-afc-013-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "6-vinyl-underscallop-picket-fence-afc-013-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  

 	 "5-vinyl-underscallop-picket-fence-afc-003-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC003WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC003WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC003WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC003WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC003WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC003WH10DD"
		 }
	 ],  
	 "5-vinyl-underscallop-picket-fence-afc-003-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC003TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC003TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC003TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC003TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC003TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC003TAN10DD"
		 }
	 ], 
 	//  "5-vinyl-underscallop-picket-fence-afc-003-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "5-vinyl-underscallop-picket-fence-afc-003-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "5-vinyl-underscallop-picket-fence-afc-003-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  

	 "4-vinyl-underscallop-picket-fence-afc-97-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC97WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC97WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC97WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC97WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC97WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC97WH10DD"
		 }
	 ], 
	 "4-vinyl-underscallop-picket-fence-afc-97-tan": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC97TAN3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC97TAN4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC97TAN5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC97TAN6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC97TAN8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC97TAN10DD"
		 }
	 ],  
 	 "4-vinyl-underscallop-picket-fence-afc-97-adobe": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC97AD3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC97AD4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC97AD5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC97AD6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC97AD8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC97AD10DD"
		 }
	 ],  
	//  "4-vinyl-underscallop-picket-fence-afc-97-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ], 
	//  "4-vinyl-underscallop-picket-fence-afc-97-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  

	 "5-vinyl-3-rail-ranch-rail-fence-afc-19a-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC19AWH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC19AWH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC19AWH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC19AWH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC19AWH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC19AWH10DD"
		 }
	 ],  
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-tan": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-mocha-walnut": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-green-teak": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-chai-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "5-vinyl-3-rail-ranch-rail-fence-afc-19a-aspen-latte": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	 	 	 	 	 	 

	 "3-vinyl-2-rail-ranch-rail-fence-afc-302-white": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (3' opening)",
			 "Opening": 3,
			 "ID": "GAFC302WH3SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "GAFC302WH4SS"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "GAFC302WH5SS"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "GAFC302WH6DD"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "GAFC302WH8DD"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "GAFC302WH10DD"
		 }
	 ]  
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-tan": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],  
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-adobe": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-light-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-dark-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-mocha-walnut": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-green-teak": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-chai-gray": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],
	//  "3-vinyl-2-rail-ranch-rail-fence-afc-302-aspen-latte": [
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (3' opening)",
	// 		 "Opening": 3,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (4' opening)",
	// 		 "Opening": 4,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Single",
	// 		 "Name": "Single Gate (5' opening)",
	// 		 "Opening": 5,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (6' opening)",
	// 		 "Opening": 6,
	// 		 "ID": ""
	// 	 },
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (8' opening)",
	// 		 "Opening": 8,
	// 		 "ID": ""
	// 	 },              
	// 	 {
	// 		 "Key": "Double",
	// 		 "Name": "Double Gate (10' opening)",
	// 		 "Opening": 10,
	// 		 "ID": ""
	// 	 }
	//  ],	 

 };
 
 
 var CHAIN_LINK_OPENINGS = { 
	 "36-residential-galvanized-chain-link": [
    	 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CL-SS-4X3"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CL-SS-6X3"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CL-DD-8X3"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CL-DD-10X3"
		 }
	 ],
	 "42-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CL-SS-4X42"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CL-SS-6X42"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CL-DD-8X42"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CL-DD-10X42"
		 }
	 ],
	 "42-residential-black-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "BCL-SS-4x42"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "BCL-SS-6x42"
		 },
		   {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "BCL-DD-8x42"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "BCL-DD-10x42"
		 }
	 ],
	 "48-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CL-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CL-SS-6X4"
		 },
	     {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CL-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CL-DD-10X4"
		 }
	 ],
	 "48-residential-black-chain-link": [
    	   {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "BCL-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "BCL-SS-6x4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "BCL-DD-8X4"
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "BCL-DD-10x4"
		 }
	 ],   
     "48-light-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X4"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X4"
		 }
     ],    
     "48-light-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X4"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X4"
		 }
     ],    
     "48-medium-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X4"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X4"
		 }
     ],
     "48-medium-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X4"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X4"
		 }
     ],    
     "48-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X4"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X4"
		 }
     ],   
      "48-heavy-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X4"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X4"
		 }
     ],    
	 "60-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CL-SS-4X5"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CL-SS-6X5"
		 },
		{
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CL-DD-8X5"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CL-DD-10X5"
		 }
	 ],
	 "60-residential-black-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "BCL-SS-4X5"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "BCL-SS-6x5"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "BCL-DD-8X5"
		 },              
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "BCL-DD-10x5"
		 }
	 ],
     "60-light-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X5"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X5"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X5"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X5"
		 }
     ],
     "60-medium-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X5"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X5"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X5"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X5"
		 }
     ],           
     "60-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X5"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X5"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X5"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X5"
		 }
     ],   
	 "72-residential-galvanized-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CL-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CL-SS-6X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CL-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CL-DD-10X6"
		 }
	 ],
	 "72-residential-black-chain-link": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "BCL-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "BCL-SS-6x6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "BCL-DD8X6"
		 },      
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "BCL-DD-10X6"
		 }
	 ],
     "72-light-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X6"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X6"
		 }
     ],
     "72-light-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X6"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X6"
		 }
     ],    
     "72-medium-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X6"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X6"
		 }
     ],   
     "72-medium-commercial-galvanized-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X6-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X6-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X6-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X6-B"
		 }
     ],
     "72-medium-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X6"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X6"
		 }
     ], 
     "72-medium-commercial-black-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X6-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X6-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X6-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X6-B"
		 }
     ],    
     "72-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X6"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X6"
		 }
     ],   
     "72-heavy-commercial-galvanized-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X6-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X6-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X6-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X6-B"
		 }
     ],    
     "72-heavy-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X6"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X6"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X6"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X6"
		 }
     ], 
     "72-heavy-commercial-black-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X6-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X6-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X6-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X6-B"
		 }
     ],     
     "84-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X7"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X7"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X7"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X7"
		 }
     ],   
     "84-heavy-commercial-galvanized-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X7-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X7-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X7-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X7-B"
		 }
     ],    
     "96-medium-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X8"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X8"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X8"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X8"
		 }
     ],    
     "96-medium-commercial-black-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X8-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X8-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X8-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X8-B"
		 }
     ],   
     "96-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X8"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X8"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X8"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X8"
		 }
     ],
     "96-heavy-commercial-galvanized-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X8-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X8-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X8-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X8-B"
		 }
     ],   
     "96-heavy-commercial-black-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X8"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X8"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X8"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X8"
		 }
     ],    
     "96-heavy-commercial-black-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCLB-SS-4X8-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCLB-SS-6X8-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCLB-DD-8X8-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCLB-DD-10X8-B"
		 }
     ],      
     "120-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X10"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X10"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X10"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X10"
		 }
     ],
     "120-heavy-commercial-galvanized-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X10-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X10-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X10-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X10-B"
		 }
     ],   
     "144-heavy-commercial-galvanized-chain-link": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X12"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X12"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X12"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X12"
		 }
     ], 
     "144-heavy-commercial-galvanized-chain-link-barbwire": [
         {
			 "Key": "Single",
			 "Name": "Single Gate (4' opening)",
			 "Opening": 4,
			 "ID": "CCL-SS-4X12-B"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "CCL-SS-6X12-B"
		 },
    	 {
			 "Key": "Double",
			 "Name": "Double Gate (8' opening)",
			 "Opening": 8,
			 "ID": "CCL-DD-8X12-B"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "CCL-DD-10X12-B"
		 }
     ]   
 };
 var OI_OPENINGS = {
	 "4-aluminum-flat-top-ornamental": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "9AF4X4GATE"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (5' opening)",
			"Opening": 5,
			"ID": "9AF4X5GATE"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "9AF4X5GATE"
		},		
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "9AF4X4GATE-PPB"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "9AF4X5GATE-PPB"
		}
	 ],
	 "4-flat-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X4M"
		},          
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIFT-SS-6X4"
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X4MD"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIFT-DD-10X4"
		}
	 ],	 
	 "4-flat-top-puppy-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X4M"
		},          
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIFT-SS-6X4"
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X4MD"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIFT-DD-10X4"
		}
	 ],	 
	 "4-spear-top-ornamental-iron": [
		 {
			 "Key": "Single",
			 "Name": "Single Gate (5' opening)",
			 "Opening": 5,
			 "ID": "OIST-SS-5X4"
		 },
		 {
			 "Key": "Single",
			 "Name": "Single Gate (6' opening)",
			 "Opening": 6,
			 "ID": "OIST-SS-6X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (6' opening)",
			 "Opening": 6,
			 "ID": "OIST-DD-6X4"
		 },
		 {
			 "Key": "Double",
			 "Name": "Double Gate (10' opening)",
			 "Opening": 10,
			 "ID": "OIST-DD-10X4"
		 }
	 ],	 
	 "5-aluminum-flat-top-ornamental": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "9AF5X4GATE"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (5' opening)",
			"Opening": 5,
			"ID": "9AF5X5GATE"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "9AF5X5GATE"
		},		
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "9AF5X4GATE-PPB"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "9AF5X5GATE-PPB"
		}
	 ],
	 "5-flat-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X5M"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIFT-SS-6X5"
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X5MD"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIFT-DD-10X5"
		}
	 ],
	 "5-spear-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X5C"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIST-SS-6X5"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X5CD"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIST-DD-10X5"
		}
	],
	 "6-aluminum-flat-top-ornamental": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "9AF6X4GATE"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (5' opening)",
			"Opening": 5,
			"ID": "9AF6X5GATE"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "9AF6X5GATE"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "9AF6X4GATE-PPB"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "9AF6X5GATE-PPB"
		}
	 ],
	 "6-flat-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X6M"
		},      
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIFT-SS-6X6"
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X6MD"
		},  
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIFT-DD-10X6"
		}
	 ],
	 "6-flat-top-puppy-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X6M"
		},      
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIFT-SS-6X6"
		},
        {
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X6MD"
		},  
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIFT-DD-10X6"
		}
	 ],	 
	 "6-spear-top-ornamental-iron": [
		{
			"Key": "Single",
			"Name": "Single Gate (4' opening)",
			"Opening": 4,
			"ID": "8GATE4X6C"
		},
		{
			"Key": "Single",
			"Name": "Single Gate (6' opening)",
			"Opening": 6,
			"ID": "OIST-SS-6X6"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (8' opening)",
			"Opening": 8,
			"ID": "8GATE4X6CD"
		},
		{
			"Key": "Double",
			"Name": "Double Gate (10' opening)",
			"Opening": 10,
			"ID": "OIST-DD-10X6"
		}
	 ]
 };
 